// @flow

import React from "react";
import { View } from "@components";
import { SingleQuestionAnswerWithConsent } from "../single-question-answer-with-consent";
import type { Question } from "../single-question-answer-with-consent";

export type AnswersType = {
  [key: string]: $Exact<{
    answer: any,
  }>,
};

export type Props = $Exact<{
  questions: Array<Question>,
  answers: AnswersType,
  columnsPerRow: number,
  onChange: Object => void,
}>;

export class QuestionAnswerContainer extends React.Component<Props> {
  static defaultProps = {
    columnsPerRow: 2,
  };

  handleChange = (value: Object) => {
    const state = { ...this.state };
    const dynamicKey = Object.keys(value)[0];

    if (state && state[dynamicKey]) {
      this.setState({
        [dynamicKey]: {
          ...state[dynamicKey],
          ...value[dynamicKey],
        },
      });

      this.props.onChange({
        answers: {
          ...state,
          [dynamicKey]: {
            ...state[dynamicKey],
            ...value[dynamicKey],
          },
        },
      });
    } else {
      const answers = {
        ...this.props.answers,
        ...state,
        ...value,
      };

      this.setState(answers);
      this.props.onChange({
        answers,
      });
    }
  };

  idName = (question: Question) => {
    return question.questionLabel ? `${question.questionLabel}-${question.id}` : `${question.id}`;
  };

  answer = (idName: string) => {
    let answer =
      this.props.answers[idName] !== undefined ? this.props.answers[idName].answer : null;
    if (this.state && this.state[idName]) {
      return this.state[idName].answer !== undefined ? this.state[idName].answer : answer;
    }
    return answer;
  };

  get questions() {
    // assures fit note question always comes first
    return this.props.questions.sort((a, b) => {
      if (a.key === "FIT_NOTE") return -1;
      if (b.key === "FIT_NOTE") return 1;
      return 0;
    });
  }

  render() {
    return (
      <View gap={4}>
        {this.questions.map((question, index) => {
          const idName = this.idName(question);

          return (
            <View key={question.id}>
              <SingleQuestionAnswerWithConsent
                onChange={this.handleChange}
                question={question}
                value={this.answer(idName)}
              />
            </View>
          );
        })}
      </View>
    );
  }
}

export default QuestionAnswerContainer;
